// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"834":"10578175","959":"f12590a3"}[chunkId] + ".chunk.js";
};